import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BaseUrl } from "../Helper/BaseUrl";
import { toastErrorr } from "../Helper/ToastMessage";


// ----------------Ward Name-----------

export const WardNameDDLAPI = createAsyncThunk("WardNameDDL", async ({ data }) => {
    const {
        UserID,
        token,
        WardName,
        handleWardNameDDL,
        Type,
        APIFlag
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    let url
    if (Type && Type == "Electrical") {
        url = `${BaseUrl}/CommonDLLData/Get_DDL_M_ELEC_Ward_Select?M_WardID=${WardName?.ID}&Flag=${APIFlag}&M_UserID=${UserID}`
    } else {
        url = `${BaseUrl}/CommonDLLData/Get_DDL_M_Ward_Select?M_UserID=${UserID}`
    }

    return fetch(url, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                { handleWardNameDDL && handleWardNameDDL(result.data) }
                return result.data
            } else {
                return result
            }
        })
})

const WardNameDDLSlice = createSlice({
    name: "WardNameDDL",
    initialState: {
        isLoading: false,
        WardDDLData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(WardNameDDLAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(WardNameDDLAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.WardDDLData = action.payload;
        });
        builder.addCase(WardNameDDLAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.WardDDLData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const WardNameDDLReducer = WardNameDDLSlice.reducer



export const VendorNameDDLAPI = createAsyncThunk("VendorNameDDL", async ({ data }) => {
    const {
        UserID,
        token,
        WardName,
        handleVendorNameDDL,
        APIFlag
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    let url
    url = `${BaseUrl}/CommonDLLData/Get_DDL_M_Ward_Wise_Vendor_Select_Select?M_WardID=${WardName}&Flag=${APIFlag}&M_UserID=${UserID}`
    return fetch(url, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                { handleVendorNameDDL && handleVendorNameDDL(result.data) }
                return result.data
            } else {
                return result
            }
        })
})

const VendorNameDDLSlice = createSlice({
    name: "VendorNameDDL",
    initialState: {
        isLoading: false,
        WardDDLData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(VendorNameDDLAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(VendorNameDDLAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.WardDDLData = action.payload;
        });
        builder.addCase(VendorNameDDLAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.WardDDLData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const VendorNameDDLReducer = VendorNameDDLSlice.reducer


// ----------------Financial Year-----------

export const FinancialYearDDLAPI = createAsyncThunk("FinancialYearDDL", async ({ data }) => {
    const {
        UserID,
        token } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    return fetch(`${BaseUrl}/CommonDLLData/Get_DDL_M_FinancialYear_Select?UserID=${UserID}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const FinancialYearDDLSlice = createSlice({
    name: "FinancialYearDDL",
    initialState: {
        isLoading: false,
        FinancialYearData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(FinancialYearDDLAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(FinancialYearDDLAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.FinancialYearData = action.payload;
        });
        builder.addCase(FinancialYearDDLAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.FinancialYearData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const FinancialYearDDLReducer = FinancialYearDDLSlice.reducer

// ----------------Month DDL-----------

export const MonthDDLAPI = createAsyncThunk("MonthDDL", async ({ data }) => {
    const {
        UserID,
        token } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    return fetch(`${BaseUrl}/CommonDLLData/Get_DDL_M_Month_Select?UserID=${UserID}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {

            if (result.code >= 200 && result.code <= 300 && result.data) {

                return result.data
            } else {
                return result
            }
        })
})

const MonthDDLSlice = createSlice({
    name: "MonthDDL",
    initialState: {
        isLoading: false,
        MonthData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(MonthDDLAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(MonthDDLAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.MonthData = action.payload;
        });
        builder.addCase(MonthDDLAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.MonthData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const MonthDDLReducer = MonthDDLSlice.reducer

// ----------------Asset DDL-----------

export const AssetDDLAPI = createAsyncThunk("AssetDDL", async ({ data }) => {
    const {
        UserID,
        token,
        M_AssetTypeID } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    return fetch(`${BaseUrl}/CommonDLLData/Get_DDL_M_Asset_Select?M_AssetTypeID=${M_AssetTypeID}&M_UserID=${UserID}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const AssetDDLSlice = createSlice({
    name: "AssetDDL",
    initialState: {
        isLoading: false,
        AssetData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(AssetDDLAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(AssetDDLAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.AssetData = action.payload;
        });
        builder.addCase(AssetDDLAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.AssetData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const AssetDDLReducer = AssetDDLSlice.reducer

// ----------------Asset Type DDL-----------

export const AssetTypeDDLAPI = createAsyncThunk("AssetTypeDDL", async ({ data }) => {
    const {
        UserID,
        token } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    return fetch(`${BaseUrl}/CommonDLLData/Get_DDL_M_AssetType_Select?M_UserID=${UserID}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const AssetTypeDDLSlice = createSlice({
    name: "AssetTypeDDL",
    initialState: {
        isLoading: false,
        AssetTypeData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(AssetTypeDDLAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(AssetTypeDDLAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.AssetTypeData = action.payload;
        });
        builder.addCase(AssetTypeDDLAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.AssetTypeData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const AssetTypeDDLReducer = AssetTypeDDLSlice.reducer

// ---------------Sector DDL-----------

export const SectorDDLAPI = createAsyncThunk("SectorDDL", async ({ data }) => {
    const {
        M_WardID,
        UserID,
        token,
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    return fetch(`${BaseUrl}/CommonDLLData/Get_DDL_M_GD_Sector_Select?M_WardID=${M_WardID ? M_WardID : '0'}&M_UserID=${UserID}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const SectorDDLSlice = createSlice({
    name: "SectorDDL",
    initialState: {
        isLoading: false,
        SectorData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(SectorDDLAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(SectorDDLAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.SectorData = action.payload;
        });
        builder.addCase(SectorDDLAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.SectorData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const SectorDDLReducer = SectorDDLSlice.reducer


// ---------------Garden DDL-----------

export const GardenDDLAPI = createAsyncThunk("GardenDDL", async ({ data }) => {
    const {
        M_WardID,
        M_GD_SectorID,
        M_AssetID,
        M_AssetTypeID,
        APIFlag,
        UserID,
        token,
        handleSectorDDL
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    let url;
    if (APIFlag == 'Garden' || APIFlag == 'RoadDivider' || APIFlag == 'OpenSpace' || APIFlag == 'TreeBelt' || APIFlag == 'Chowk') {
        url = `${BaseUrl}/CommonDLLData/Get_DDL_M_Asset_Master_Select?M_AssetID=${M_AssetID}&M_AssetTypeID=${M_AssetTypeID}&M_WardID=${M_WardID}&M_GD_SectorID=${M_GD_SectorID}&Flag=${APIFlag}&M_UserID=${UserID}`
    } else {
        url = `${BaseUrl}/CommonDLLData/Get_APK_GD_M_Ward_Sector_Wise_Asset_Select?M_WardID=${M_WardID}&M_GD_SectorID=${M_GD_SectorID}&M_UsersID=${UserID}&To=9999`
    }

    return fetch(url, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            handleSectorDDL(result?.data)
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                handleSectorDDL([])
                return result
            }
        })
})

const GardenDDLSlice = createSlice({
    name: "GardenDDL",
    initialState: {
        isLoading: false,
        DDLData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(GardenDDLAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(GardenDDLAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.GardenData = action.payload;
        });
        builder.addCase(GardenDDLAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.GardenData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const GardenDDLReducer = GardenDDLSlice.reducer


// ---------------Department DDL-----------

export const DepartmentDDLAPI = createAsyncThunk("DepartmentDDL", async ({ data }) => {
    const {
        UserID,
        token } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    return fetch(`${BaseUrl}/CommonDLLData/Get_DDL_M_Department_Select?M_UserID=${UserID}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const DepartmentDDLSlice = createSlice({
    name: "DepartmentDDL",
    initialState: {
        isLoading: false,
        DepDDLData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(DepartmentDDLAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(DepartmentDDLAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.DepDDLData = action.payload;
        });
        builder.addCase(DepartmentDDLAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.DepDDLData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const DepartmentDDLReducer = DepartmentDDLSlice.reducer

// ---------------Designation DDL-----------

export const DesignationDDLAPI = createAsyncThunk("DesignationDDL", async ({ data }) => {
    const {
        UserID,
        token,
        M_RoleID,
        M_ProjectTypeID,
        ApiFlag } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    let url
    if (ApiFlag == 'Daily_Schedule_Wise') {
        url = `${BaseUrl}/CommonDLLData/Get_DDL_Daily_Schedule_M_Designation_Select?Flag=${ApiFlag}&M_UserID=${UserID}`
    } else {
        url = `${BaseUrl}/CommonDLLData/Get_DDL_M_Designation_Select?M_UserID=${UserID}&M_RoleID=${M_RoleID ? M_RoleID : '0'}&M_ProjectTypeID=${M_ProjectTypeID ? M_ProjectTypeID : '0'}`
    }


    return fetch(url, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const DesignationDDLSlice = createSlice({
    name: "DesignationDDL",
    initialState: {
        isLoading: false,
        DesignationData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(DesignationDDLAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(DesignationDDLAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.DesignationData = action.payload;
        });
        builder.addCase(DesignationDDLAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.DesignationData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const DesignationDDLReducer = DesignationDDLSlice.reducer

// ---------------Yes / NO DDL-----------

export const YesNoDDLAPI = createAsyncThunk("YesNoDDL", async ({ data }) => {
    const {
        UserID,
        token } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    return fetch(`${BaseUrl}/CommonDLLData/Get_DDL_YesNo_Select?M_UserID=${UserID}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const YesNoDDLSlice = createSlice({
    name: "YesNoDDL",
    initialState: {
        isLoading: false,
        YesNoData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(YesNoDDLAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(YesNoDDLAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.YesNoData = action.payload;
        });
        builder.addCase(YesNoDDLAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.YesNoData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const YesNoDDLReducer = YesNoDDLSlice.reducer

export const EmployeeDDLAPI = createAsyncThunk("EmployeeDDL", async ({ data }) => {
    const {
        M_DepartmentID,
        Designation,
        M_ProjectTypeID,
        M_RoleID,
        UserID,
        token, ApiFlag, WardName } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    let url
    if (ApiFlag == 'Daily_Schedule_Wise') {
        url = `${BaseUrl}/CommonDLLData/Get_DDL_Daily_Schedule_M_Employee_Select?M_WardID=${WardName ? WardName.ID : '0'}&M_DesignationID=${Designation ? Designation.ID : '0'}&M_UserID=${UserID}`
    } else {
        url = `${BaseUrl}/CommonDLLData/Get_DDL_M_Employee_Select?M_DesignationID=${Designation ? Designation.ID : '0'}&M_DepartmentID=${M_DepartmentID ? M_DepartmentID : '0'}&M_UserID=${UserID}&M_RoleID=${M_RoleID ? M_RoleID : '0'}&M_ProjectTypeID=${M_ProjectTypeID ? M_ProjectTypeID : '0'}`
    }
    return fetch(url, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const EmployeeDDLSlice = createSlice({
    name: "EmployeeDDL",
    initialState: {
        isLoading: false,
        EmpDDLData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(EmployeeDDLAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(EmployeeDDLAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.EmpDDLData = action.payload;
        });
        builder.addCase(EmployeeDDLAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.EmpDDLData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const EmployeeDDLReducer = EmployeeDDLSlice.reducer


export const ContractorNameDDLAPI = createAsyncThunk("ContractorNameDDL", async ({ data }) => {
    const {
        M_UserID,
        token } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    return fetch(`${BaseUrl}/CommonDLLData/Get_DDL_M_Contractor_Select?M_UserID=${M_UserID}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const ContractorNameDDLSlice = createSlice({
    name: "ContractorNameDDL",
    initialState: {
        isLoading: false,
        ContractorNameDDLData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(ContractorNameDDLAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(ContractorNameDDLAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.ContractorNameDDLData = action.payload;
        });
        builder.addCase(ContractorNameDDLAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.ContractorNameDDLData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const ContractorNameDDLReducer = ContractorNameDDLSlice.reducer


// Electric Contractor Name DDL
export const ElEContractorNameDDLAPI = createAsyncThunk("ElEContractorNameDDL", async ({ data }) => {
    const {
        M_ProjectTypeID,
        Flag,
        M_UserID,
        token } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    return fetch(`${BaseUrl}/CommonDLLData/Get_DDL_M_ProjectTypeWise_M_ProjectSelect?M_ProjectTypeID=${M_ProjectTypeID}&Flag=${Flag}&M_UserID=${M_UserID}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const ElEContractorNameDDLSlice = createSlice({
    name: "ElEContractorNameDDL",
    initialState: {
        isLoading: false,
        ContractorNameDDLData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(ElEContractorNameDDLAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(ElEContractorNameDDLAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.ContractorNameDDLData = action.payload;
        });
        builder.addCase(ElEContractorNameDDLAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.ContractorNameDDLData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const ElEContractorNameDDLReducer = ElEContractorNameDDLSlice.reducer


//

// Electric Contractor Name DDL
export const ElEProjectWiseContractorDDLAPI = createAsyncThunk("ElEProjectWiseContractorDDL", async ({ data }) => {
    const {
        M_ProjectTypeID,
        Flag,
        M_UserID,
        token } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    return fetch(`${BaseUrl}/CommonDLLData/Get_DDL_M_ProjectWiseContractor_Select?M_ProjectID=${M_ProjectTypeID}&Flag=${Flag}&M_UserID=${M_UserID}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const ElEProjectWiseContractorDDLSlice = createSlice({
    name: "ElEProjectWiseContractorDDL",
    initialState: {
        isLoading: false,
        ContractorNameDDLData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(ElEProjectWiseContractorDDLAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(ElEProjectWiseContractorDDLAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.ContractorNameDDLData = action.payload;
        });
        builder.addCase(ElEProjectWiseContractorDDLAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.ContractorNameDDLData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const ElEProjectWiseContractorDDLReducer = ElEProjectWiseContractorDDLSlice.reducer


// ----------------Zone Master--------------------

export const ZoneDDLAPI = createAsyncThunk("ZoneDDL", async ({ data }) => {
    const {
        M_DepartmentID,
        M_DesignationID,
        UserID,
        token } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    return fetch(`${BaseUrl}/CommonDLLData/Get_DDL_M_Zone_Select?M_UserID=${UserID}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const ZoneDDLSlice = createSlice({
    name: "ZoneDDL",
    initialState: {
        isLoading: false,
        ZoneData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(ZoneDDLAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(ZoneDDLAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.ZoneData = action.payload;
        });
        builder.addCase(ZoneDDLAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.ZoneData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const ZoneDDLReducer = ZoneDDLSlice.reducer


// / ----------------Project Name Master--------------------

export const ProjectNameDDLAPI = createAsyncThunk("ProjectNameDDL", async ({ data }) => {
    const {
        UserID,
        token } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    return fetch(`${BaseUrl}/CommonDLLData/Get_DDL_M_Project_Select?M_UserID=${UserID}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const ProjectNameDDLSlice = createSlice({
    name: "ProjectNameDDL",
    initialState: {
        isLoading: false,
        ProjectData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(ProjectNameDDLAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(ProjectNameDDLAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.ProjectData = action.payload;
        });
        builder.addCase(ProjectNameDDLAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.ProjectData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const ProjectNameDDLReducer = ProjectNameDDLSlice.reducer

// / ----------------Project Name Master--------------------

export const GDProjectNameDDLAPI = createAsyncThunk("GDProjectNameDDL", async ({ data }) => {
    const {

        M_WardID,
        M_ProjectTypeID,
        Flag,
        M_UserID,
        token
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    return fetch(`${BaseUrl}/CommonDLLData/Get_DDL_M_ProjectTypeWise_M_ProjectSelect?M_WardID=${M_WardID}&M_ProjectTypeID=${M_ProjectTypeID ? M_ProjectTypeID : '0'}&Flag=${Flag}&M_UserID=${M_UserID}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const GDProjectNameDDLSlice = createSlice({
    name: "GDProjectNameDDL",
    initialState: {
        isLoading: false,
        GDProjectData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(GDProjectNameDDLAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(GDProjectNameDDLAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.GDProjectData = action.payload;
        });
        builder.addCase(GDProjectNameDDLAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.GDProjectData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const GDProjectNameDDLReducer = GDProjectNameDDLSlice.reducer

export const WorkTypeDDLAPI = createAsyncThunk("WorkTypeDDL", async ({ data }) => {
    const {
        UserID,
        token } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    return fetch(`${BaseUrl}/CommonDLLData/Get_DDL_M_WorkType_Select?M_UserID=${UserID}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const WorkTypeDDLSlice = createSlice({
    name: "WorkTypeDDL",
    initialState: {
        isLoading: false,
        WorkTypeData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(WorkTypeDDLAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(WorkTypeDDLAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.WorkTypeData = action.payload;
        });
        builder.addCase(WorkTypeDDLAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.WorkTypeData = null;
            toastErrorr('Something went wrong')
        });
    },
})
export const WorkTypeDDLReducer = WorkTypeDDLSlice.reducer


export const WorkSubTypeDDLAPI = createAsyncThunk("WorkSubTypeDDL", async ({ data }) => {
    const {
        M_WorkTypeID,
        M_UserID,
        token } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/CommonDLLData/Get_WEB_GD_DDL_M_WorkSubType_Select?M_WorkTypeID=${M_WorkTypeID ? M_WorkTypeID : '0'}&M_UserID=${M_UserID}`, requestOptions)

        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const WorkSubTypeDDLSlice = createSlice({
    name: "WorkSubTypeDDL",
    initialState: {
        isLoading: false,
        WorkSubTypeData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(WorkSubTypeDDLAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(WorkSubTypeDDLAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.WorkSubTypeData = action.payload;
        });
        builder.addCase(WorkSubTypeDDLAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.WorkSubTypeData = null;
            toastErrorr('Something went wrong')
        });
    },
})
export const WorkSubTypeDDLReducer = WorkSubTypeDDLSlice.reducer


export const WorkNameDDLAPI = createAsyncThunk("WorkNameDDL", async ({ data }) => {
    const {
        M_WorkTypeID,
        M_WorkSubTypeID,
        M_UserID,
        token } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/CommonDLLData/Get_WEB_GD_DDL_M_Work_Select?M_WorkTypeID=${M_WorkTypeID ? M_WorkTypeID : '0'}&M_WorkSubTypeID=${M_WorkSubTypeID ? M_WorkSubTypeID : '0'}&M_UserID=${M_UserID}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const WorkNameDDLSlice = createSlice({
    name: "WorkNameDDL",
    initialState: {
        isLoading: false,
        WorkNameData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(WorkNameDDLAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(WorkNameDDLAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.WorkNameData = action.payload;
        });
        builder.addCase(WorkNameDDLAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.WorkNameData = null;
            toastErrorr('Something went wrong')
        });
    },
})
export const WorkNameDDLReducer = WorkNameDDLSlice.reducer

//  Update Work Name DDl API

export const UpdateWorkNameDDLAPI = createAsyncThunk("UpdateWorkNameDDL", async ({ data }) => {
    const {
        M_ProjectID,
        M_UserID,
        token } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/CommonDLLData/Get_DDL_M_ProjectWiseM_Work_Select?M_ProjectID=${M_ProjectID ? M_ProjectID : '0'}&M_UserID=${M_UserID}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const UpdateWorkNameDDLSlice = createSlice({
    name: "UpdateWorkNameDDL",
    initialState: {
        isLoading: false,
        UpdateWorkNameData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(UpdateWorkNameDDLAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(UpdateWorkNameDDLAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.UpdateWorkNameData = action.payload;
        });
        builder.addCase(UpdateWorkNameDDLAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.UpdateWorkNameData = null;
            toastErrorr('Something went wrong')
        });
    },
})
export const UpdateWorkNameDDLReducer = UpdateWorkNameDDLSlice.reducer


// Project Wise Work Name DDL
export const ElEProjectWiseWorkNameDDLAPI = createAsyncThunk("ElEProjectWiseWorkNameDDL", async ({ data }) => {
    const {
        M_ProjectID,
        Flag,
        M_UserID,
        token } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/CommonDLLData/Get_DDL_M_ELEC_ProjectWiseWork_Select?M_ProjectID=${M_ProjectID}&Flag=${Flag}&M_UserID=${M_UserID}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const ElEProjectWiseWorkNameDDLSlice = createSlice({
    name: "ElEProjectWiseWorkNameDDL",
    initialState: {
        isLoading: false,
        UpdateWorkNameData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(ElEProjectWiseWorkNameDDLAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(ElEProjectWiseWorkNameDDLAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.UpdateWorkNameData = action.payload;
        });
        builder.addCase(ElEProjectWiseWorkNameDDLAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.UpdateWorkNameData = null;
            toastErrorr('Something went wrong')
        });
    },
})
export const ElEProjectWiseWorkNameDDLReducer = ElEProjectWiseWorkNameDDLSlice.reducer


export const LocationNameDDLAPI = createAsyncThunk("LocationNameDDL", async ({ data }) => {
    const {
        WardName,
        M_UserID,
        token } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/CommonDLLData/Get_APK_RM_DDL_M_RM_Location_Select?M_WardID=${WardName.ID ? WardName.ID : '0'}&M_UserID=${M_UserID}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const LocationNameDDLSlice = createSlice({
    name: "LocationNameDDL",
    initialState: {
        isLoading: false,
        LocationNameData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(LocationNameDDLAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(LocationNameDDLAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.LocationNameData = action.payload;
        });
        builder.addCase(LocationNameDDLAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.LocationNameData = null;
            toastErrorr('Something went wrong')
        });
    },
})
export const LocationNameDDLReducer = LocationNameDDLSlice.reducer

export const RoadWorkNameDDLAPI = createAsyncThunk("RoadWorkNameDDL", async ({ data }) => {
    const {
        Flag,
        M_UserID,
        token } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/CommonDLLData/Get_WEB_DDL_M_RM_Work_Select?Flag=${Flag}&M_UserID=${M_UserID}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const RoadWorkNameDDLSlice = createSlice({
    name: "RoadWorkNameNameDDL",
    initialState: {
        isLoading: false,
        RoadWorkNameData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(RoadWorkNameDDLAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(RoadWorkNameDDLAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.RoadWorkNameData = action.payload;
        });
        builder.addCase(RoadWorkNameDDLAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.RoadWorkNameData = null;
            toastErrorr('Something went wrong')
        });
    },
})
export const RoadWorkNameDDLReducer = RoadWorkNameDDLSlice.reducer

// -----------------------Project Type -------------------

export const ProjectTypeNameDDLAPI = createAsyncThunk("ProjectTypeNameDDL", async ({ data }) => {
    const {
        Flag,
        UserID,
        M_ProjectTypeID,
        token } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/CommonDLLData/Get_DDL_M_ProjectType_Select?M_ProjectTypeID=${M_ProjectTypeID ? M_ProjectTypeID : '0'}&M_UserID=${UserID}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const ProjectTypeNameDDLSlice = createSlice({
    name: "ProjectTypeNameDDL",
    initialState: {
        isLoading: false,
        ProjectTypeNameData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(ProjectTypeNameDDLAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(ProjectTypeNameDDLAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.ProjectTypeNameData = action.payload;
        });
        builder.addCase(ProjectTypeNameDDLAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.ProjectTypeNameData = null;
            toastErrorr('Something went wrong')
        });
    },
})
export const ProjectTypeNameDDLReducer = ProjectTypeNameDDLSlice.reducer

// -----------------------Project Type -------------------

export const RoleNameDDLAPI = createAsyncThunk("RoleNameDDL", async ({ data }) => {
    const {
        Flag,
        M_ProjectTypeID,
        UserID,
        token } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/CommonDLLData/Get_DDL_M_Role_Select?M_UserID=${UserID}&M_ProjectTypeID=${M_ProjectTypeID ? M_ProjectTypeID : '0'}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const RoleNameDDLSlice = createSlice({
    name: "RoleNameDDL",
    initialState: {
        isLoading: false,
        RoleNameData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(RoleNameDDLAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(RoleNameDDLAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.RoleNameData = action.payload;
        });
        builder.addCase(RoleNameDDLAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.RoleNameData = null;
            toastErrorr('Something went wrong')
        });
    },
})
export const RoleNameDDLReducer = RoleNameDDLSlice.reducer

// -----------------------Status DDL -------------------

export const StatusDDLAPI = createAsyncThunk("StatusDDL", async ({ data }) => {
    const {
        Flag,
        UserID,
        token } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/CommonDLLData/Get_WEB_DDL_GD_M_Status_Select?M_UserID=${UserID}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const StatusDDLSlice = createSlice({
    name: "StatusDDL",
    initialState: {
        isLoading: false,
        StatusData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(StatusDDLAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(StatusDDLAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.StatusData = action.payload;
        });
        builder.addCase(StatusDDLAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.StatusData = null;
            toastErrorr('Something went wrong')
        });
    },
})
export const StatusDDLReducer = StatusDDLSlice.reducer

// -----------------------Severage Work Type DDL -------------------

export const SeverageWorkTypeDDLAPI = createAsyncThunk("SeverageWorkTypeDDL", async ({ data }) => {
    const {
        Flag,
        UserID,
        token } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/CommonDLLData/Get_WEB_SW_DDL_M_SW_WorkType_Select?M_UserID=${UserID}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const SeverageWorkTypeSlice = createSlice({
    name: "SeverageWorkTypeDDL",
    initialState: {
        isLoading: false,
        SeverageData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(SeverageWorkTypeDDLAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(SeverageWorkTypeDDLAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.SeverageData = action.payload;
        });
        builder.addCase(SeverageWorkTypeDDLAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.SeverageData = null;
            toastErrorr('Something went wrong')
        });
    },
})
export const SeverageWorkTypeReducer = SeverageWorkTypeSlice.reducer

// -----------------------Severage Pumping Station DDL -------------------

export const PumpingStationDDLAPI = createAsyncThunk("PumpingStationDDL", async ({ data }) => {
    const {
        Flag,
        UserID,
        WardName,
        token } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/CommonDLLData/Get_WEB_SW_DDL_M_SW_PumpingStation_Select?M_WardID=${WardName ? WardName : '0'}&M_UserID=${UserID}&Flag=Master`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const PumpingStationSlice = createSlice({
    name: "PumpingStationDDL",
    initialState: {
        isLoading: false,
        PumpingData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(PumpingStationDDLAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(PumpingStationDDLAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.PumpingData = action.payload;
        });
        builder.addCase(PumpingStationDDLAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.PumpingData = null;
            toastErrorr('Something went wrong')
        });
    },
})
export const PumpingStationReducer = PumpingStationSlice.reducer

// -----------------------Severage Work Period DDL -------------------

export const WorkPeriodDDLAPI = createAsyncThunk("WorkPeriodDDL", async ({ data }) => {
    const {
        Flag,
        UserID,
        WardName,
        token } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/CommonDLLData/Get_WEB_SW_DDL_M_SW_WorkPeriod_Select?M_UserID=${UserID}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const WorkPeriodDDLSlice = createSlice({
    name: "WorkPeriodDDL",
    initialState: {
        isLoading: false,
        WorkPeriodData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(WorkPeriodDDLAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(WorkPeriodDDLAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.WorkPeriodData = action.payload;
        });
        builder.addCase(WorkPeriodDDLAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.WorkPeriodData = null;
            toastErrorr('Something went wrong')
        });
    },
})
export const WorkPeriodDDLReducer = WorkPeriodDDLSlice.reducer

export const WorkAssignByDDLAPI = createAsyncThunk("WorkAssignByDDL", async ({ data }) => {
    const {
        Flag,
        UserID,
        token } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/CommonDLLData/Get_WEB_DDL_GD_WorkAssignBy_Select?Flag=${Flag}&M_UserID=${UserID}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const WorkAssignByDDLSlice = createSlice({
    name: "WorkAssignByDDL",
    initialState: {
        isLoading: false,
        WorkAssignByData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(WorkAssignByDDLAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(WorkAssignByDDLAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.WorkAssignByData = action.payload;
        });
        builder.addCase(WorkAssignByDDLAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.WorkAssignByData = null;
            toastErrorr('Something went wrong')
        });
    },
})
export const WorkAssignByDDLReducer = WorkAssignByDDLSlice.reducer


// ------------------------Location DDL ------------

export const SeverageLocationDDLAPI = createAsyncThunk("SeverageLocationDDL", async ({ data }) => {
    const {
        WardName,
        Flag,
        M_UserID,
        token } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/CommonDLLData/Get_WEB_SW_DDL_M_SW_Location_Select?M_WardID=${WardName.ID ? WardName.ID : '0'}&M_UserID=${M_UserID}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const SeverageLocationDDLSlice = createSlice({
    name: "SeverageLocationDDL",
    initialState: {
        isLoading: false,
        SeverageLocationData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(SeverageLocationDDLAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(SeverageLocationDDLAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.SeverageLocationData = action.payload;
        });
        builder.addCase(SeverageLocationDDLAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.SeverageLocationData = null;
            toastErrorr('Something went wrong')
        });
    },
})
export const SeverageLocationDDLReducer = SeverageLocationDDLSlice.reducer

// ------------------------Location DDL ------------

export const ServiceTypeDDLAPI = createAsyncThunk("ServiceTypeDDL", async ({ data }) => {
    const {
        WardName,
        Flag,
        UserID,
        token } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/CommonDLLData/Get_WEB_SW_DDL_M_SW_ServiceType_Select?M_UserID=${UserID}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const ServiceTypeDDLSlice = createSlice({
    name: "ServiceTypeDDL",
    initialState: {
        isLoading: false,
        ServiceTypeData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(ServiceTypeDDLAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(ServiceTypeDDLAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.ServiceTypeData = action.payload;
        });
        builder.addCase(ServiceTypeDDLAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.ServiceTypeData = null;
            toastErrorr('Something went wrong')
        });
    },
})
export const ServiceTypeDDLReducer = ServiceTypeDDLSlice.reducer

// ------------------Water Supply Location DDL ----------------
export const WaterSupplyLocationDDLAPI = createAsyncThunk("WaterSupplyLocationDDL", async ({ data }) => {
    const {
        WardName,
        Flag,
        M_UserID,
        token } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/CommonDLLData/Get_WEB_WS_DDL_M_WS_Location_Select?M_WardID=${WardName ? WardName : '0'}&M_UserID=${M_UserID}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const WaterSupplyLocationDDLSlice = createSlice({
    name: "WaterSupplyLocationDDL",
    initialState: {
        isLoading: false,
        WaterSupplyLocationData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(WaterSupplyLocationDDLAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(WaterSupplyLocationDDLAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.WaterSupplyLocationData = action.payload;
        });
        builder.addCase(WaterSupplyLocationDDLAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.WaterSupplyLocationData = null;
            toastErrorr('Something went wrong')
        });
    },
})
export const WaterSupplyLocationDDLReducer = WaterSupplyLocationDDLSlice.reducer

// Water Supply User Role DDL

export const WaterSupplyUserRoleDataDDLAPI = createAsyncThunk("WaterSupplyUserRoleDataDDL", async ({ data }) => {
    const {
        M_ProjectTypeID,
        UserID,
        token } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/CommonDLLData/Get_DDL_M_ProjectTypeWiseM_Role_Select?M_ProjectTypeID=${M_ProjectTypeID}&M_UserID=${UserID}`, requestOptions)

        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const WaterSupplyUserRoleDataDDLSlice = createSlice({
    name: "WaterSupplyUserRoleDataDDL",
    initialState: {
        isLoading: false,
        WaterSupplyUserRoleData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(WaterSupplyUserRoleDataDDLAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(WaterSupplyUserRoleDataDDLAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.WaterSupplyUserRoleData = action.payload;
        });
        builder.addCase(WaterSupplyUserRoleDataDDLAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.WaterSupplyUserRoleData = null;
            toastErrorr('Something went wrong')
        });
    },
})
export const WaterSupplyUserRoleDDLReducer = WaterSupplyUserRoleDataDDLSlice.reducer

// Water Supply User Data DDL

export const WaterSupplyUserDataDDLAPI = createAsyncThunk("WaterSupplyUserDataDDL", async ({ data }) => {
    const {
        M_RoleID,
        M_ProjectTypeID,
        M_UserID,
        token } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/CommonDLLData/Get_DDL_M_ProjectTypeWiseM_RoleWiseUserDetails_Select?M_RoleID=${M_RoleID}&M_ProjectTypeID=${M_ProjectTypeID}&M_UserID=${M_UserID}`, requestOptions)

        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const WaterSupplyUserDataDDLSlice = createSlice({
    name: "WaterSupplyUserDataDDL",
    initialState: {
        isLoading: false,
        WaterSupplyUserData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(WaterSupplyUserDataDDLAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(WaterSupplyUserDataDDLAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.WaterSupplyUserData = action.payload;
        });
        builder.addCase(WaterSupplyUserDataDDLAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.WaterSupplyUserData = null;
            toastErrorr('Something went wrong')
        });
    },
})
export const WaterSupplyUserDDLReducer = WaterSupplyUserDataDDLSlice.reducer

// ---------------------------Junction Name----------------------------------------

export const JunctionNameDDLAPI = createAsyncThunk("JunctionNameDDL", async ({ data }) => {
    const {
        WardName,
        M_UserID,
        token } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/CommonDLLData/Get_APK_WS_DDL_M_WS_Junction_Select?M_WardID=${WardName ? WardName : '0'}&M_UserID=${M_UserID}`, requestOptions)

        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const JunctionNameDDLSlice = createSlice({
    name: "JunctionNameDDL",
    initialState: {
        isLoading: false,
        JunctionNameData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(JunctionNameDDLAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(JunctionNameDDLAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.JunctionNameData = action.payload;
        });
        builder.addCase(JunctionNameDDLAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.JunctionNameData = null;
            toastErrorr('Something went wrong')
        });
    },
})
export const JunctionNameDDLReducer = JunctionNameDDLSlice.reducer


// ---------------------------Junction Name----------------------------------------

export const EcoliDDLAPI = createAsyncThunk("EcoliDDL", async ({ data }) => {
    const {
        Flag,
        M_UserID,
        token } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/CommonDLLData/Get_APK_WS_DDL_M_Indicator_Select?Flag=${Flag}&M_UserID=${M_UserID}`, requestOptions)

        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const EcoliDDLSlice = createSlice({
    name: "EcoliDDL",
    initialState: {
        isLoading: false,
        EcoliData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(EcoliDDLAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(EcoliDDLAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.EcoliData = action.payload;
        });
        builder.addCase(EcoliDDLAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.EcoliData = null;
            toastErrorr('Something went wrong')
        });
    },
})
export const EcoliDDLReducer = EcoliDDLSlice.reducer

// ---------------------------Pumping Station watersupply Name----------------------------------------


export const WaterSupplyPumpingStationDDLAPI = createAsyncThunk("WaterSupplyPumpingStationDDL", async ({ data }) => {
    const {
        M_WardID,
        UserID,
        token,
        DashProjectTypeId,
        RoleID
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    let url
    if (DashProjectTypeId == 6 && RoleID != '16') {
        url = `${BaseUrl}/CommonDLLData/Get_WEB_WS_DDL_M_Distri_WS_PumpStation_Select?M_WardID=${M_WardID ? M_WardID : '0'}&M_UserID=${UserID}`
    }
    else if (DashProjectTypeId == 9) {
        url = `${BaseUrl}/CommonDLLData/Get_WEB_DDL_M_TTP_PumpStation_Select?M_WardID=${M_WardID ? M_WardID : '0'}&M_UserID=${UserID}`
    }
    else {
        url = `${BaseUrl}/CommonDLLData/Get_WEB_WS_DDL_M_WS_PumpStation_Select?M_WardID=${M_WardID ? M_WardID : '0'}&M_UserID=${UserID}`
    }

    return fetch(url, requestOptions)

        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const WaterSupplyPumpingStationDDLSlice = createSlice({
    name: "WaterSupplyPumpingStationDDL",
    initialState: {
        isLoading: false,
        WaterSupplyPumpingStationData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(WaterSupplyPumpingStationDDLAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(WaterSupplyPumpingStationDDLAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.WaterSupplyPumpingStationData = action.payload;
        });
        builder.addCase(WaterSupplyPumpingStationDDLAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.WaterSupplyPumpingStationData = null;
            toastErrorr('Something went wrong')
        });
    },
})
export const WaterSupplyPumpingStationDDLReducer = WaterSupplyPumpingStationDDLSlice.reducer

// ---------------------------Location watersupply Name----------------------------------------
export const DistributionLineLocationDDLAPI = createAsyncThunk("DistributionLineLocationDDL", async ({ data }) => {
    const {
        M_WardID,
        M_UserID,
        token,
        DashProjectTypeId
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    let url
    if (DashProjectTypeId && DashProjectTypeId == 9) { // TTP
        url = `${BaseUrl}/CommonDLLData/Get_WEB_DDL_M_TTP_Location_Select?M_WardID=${M_WardID ? M_WardID : '0'}&M_UserID=${M_UserID}`
    } else {
        url = `${BaseUrl}/CommonDLLData/Get_WEB_WS_DDL_M_Distri_WS_Location_Select?M_WardID=${M_WardID ? M_WardID : '0'}&M_UserID=${M_UserID}`
    }
    return fetch(url, requestOptions)

        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const DistributionLineLocationDDLSlice = createSlice({
    name: "DistributionLineLocationDDL",
    initialState: {
        isLoading: false,
        DistributionLineLocationData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(DistributionLineLocationDDLAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(DistributionLineLocationDDLAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.DistributionLineLocationData = action.payload;
        });
        builder.addCase(DistributionLineLocationDDLAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.DistributionLineLocationData = null;
            toastErrorr('Something went wrong')
        });
    },
})
export const DistributionLineLocationDDLReducer = DistributionLineLocationDDLSlice.reducer

// -----------------------------Mainfeeder LocationName DDL -----------------------

export const MainFeederLocationDDLAPI = createAsyncThunk("MainFeederLocationDDL", async ({ data }) => {
    const {
        WardName,
        M_UserID,
        token } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/CommonDLLData/Get_WEB_WS_DDL_M_Distri_WS_Location_Select?M_WardID=${WardName ? WardName : '0'}&M_UserID=${M_UserID}`, requestOptions)

        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const MainFeederLocationDDLSlice = createSlice({
    name: "MainFeederLocationDDL",
    initialState: {
        isLoading: false,
        MainFeederLocationData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(MainFeederLocationDDLAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(MainFeederLocationDDLAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.MainFeederLocationData = action.payload;
        });
        builder.addCase(MainFeederLocationDDLAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.MainFeederLocationData = null;
            toastErrorr('Something went wrong')
        });
    },
})
export const MainFeederLocationDDLReducer = MainFeederLocationDDLSlice.reducer

// ---------------------------Pipeline watersupply Name----------------------------------------
export const PipelineDDLAPI = createAsyncThunk("PipelineDDL", async ({ data }) => {
    const {
        M_WS_JunctionID,
        M_UserID,
        token,
        DashProjectTypeId,
        M_Distri_WS_LocationID,
        RoleID
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    let url

    if (DashProjectTypeId == 6 && RoleID != '16') {
        url = `${BaseUrl}/CommonDLLData/Get_WEB_WS_DDL_M_Distri_WS_PipeLine_Select?M_Distri_WS_LocationID=${M_Distri_WS_LocationID ? M_Distri_WS_LocationID : '0'}&M_UserID=${M_UserID}`
    }
    else if (DashProjectTypeId == 9) {
        url = `${BaseUrl}/CommonDLLData/Get_WEB_DDL_M_TTP_PipeLine_Select?M_TTP_LocationID=${M_Distri_WS_LocationID ? M_Distri_WS_LocationID : '0'}&M_UserID=${M_UserID}`
    }
    else {
        url = `${BaseUrl}/CommonDLLData/Get_WEB_WS_DDL_M_WS_PipeLine_Select?M_WS_JunctionID=${M_WS_JunctionID ? M_WS_JunctionID : '0'}&M_UserID=${M_UserID}`
    }

    return fetch(url, requestOptions)

        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const PipelineDDLSlice = createSlice({
    name: "PipelineDDL",
    initialState: {
        isLoading: false,
        PipelineData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(PipelineDDLAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(PipelineDDLAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.PipelineData = action.payload;
        });
        builder.addCase(PipelineDDLAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.PipelineData = null;
            toastErrorr('Something went wrong')
        });
    },
})
export const PipelineDDLReducer = PipelineDDLSlice.reducer

// ---------------------------Work Period watersupply Name----------------------------------------
export const WaterSupplyWorkPeriodDDLAPI = createAsyncThunk("WaterSupplyWorkPeriodDDL", async ({ data }) => {
    const {
        DashProjectTypeId,
        M_UserID,
        token } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    let url
    if (DashProjectTypeId == '6') {
        url = `${BaseUrl}/CommonDLLData/Get_WEB_WS_DDL_M_Distri_WorkPeriod_Select?M_UserID=${M_UserID}`
    }
    else if (DashProjectTypeId == '9') {
        url = `${BaseUrl}/CommonDLLData/Get_WEB_DDL_M_TTP_WorkPeriod_Select?M_UserID=${M_UserID}`
    }
    else {
        url = `${BaseUrl}/CommonDLLData/Get_WEB_WS_DDL_M_WS_WorkPeriod_Select?M_UserID=${M_UserID}`
    }

    return fetch(url, requestOptions)

        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const WaterSupplyWorkPeriodDDLSlice = createSlice({
    name: "WaterSupplyWorkPeriodDDL",
    initialState: {
        isLoading: false,
        WaterSupplyWorkPeriodData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(WaterSupplyWorkPeriodDDLAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(WaterSupplyWorkPeriodDDLAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.WaterSupplyWorkPeriodData = action.payload;
        });
        builder.addCase(WaterSupplyWorkPeriodDDLAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.WaterSupplyWorkPeriodData = null;
            // toastErrorr('Something went wrong')
        });
    },
})
export const WaterSupplyWorkPeriodDDLReducer = WaterSupplyWorkPeriodDDLSlice.reducer

// -------------------Report Project Type DDL -------

export const ReportProjectTypeDDLAPI = createAsyncThunk("ReportProjectTypeDDL", async ({ data }) => {
    const {
        UserID,
        token,
        M_ProjectTypeID
     } = data

    const ProjectType = sessionStorage.getItem("FJ853K")

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/CommonDLLData/Get_RM_DDL_ProjectTypeForPenaltyReport_Select?M_ProjectTypeID=${ProjectType ?? M_ProjectTypeID}&M_UserID=${UserID}`, requestOptions)

        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const ReportProjectTypeDDLSlice = createSlice({
    name: "ReportProjectTypeDDL",
    initialState: {
        isLoading: false,
        ReportProjectTypeData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(ReportProjectTypeDDLAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(ReportProjectTypeDDLAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.ReportProjectTypeData = action.payload;
        });
        builder.addCase(ReportProjectTypeDDLAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.ReportProjectTypeData = null;
            toastErrorr('Something went wrong')
        });
    },
})
export const ReportProjectTypeDDLReducer = ReportProjectTypeDDLSlice.reducer

export const ReportProjectNameDDLAPI = createAsyncThunk("ReportProjectNameDDL", async ({ data }) => {
    const {
        UserID,
        token,
        M_ProjectTypeID } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/CommonDLLData/Get_RM_DDL_ProjectNameForPenaltyReport_Select?M_ProjectTypeID=${M_ProjectTypeID ? M_ProjectTypeID : '0'}&M_UserID=${UserID}`, requestOptions)

        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const ReportProjectNameDDLSlice = createSlice({
    name: "ReportProjectNameDDL",
    initialState: {
        isLoading: false,
        ReportProjectNameData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(ReportProjectNameDDLAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(ReportProjectNameDDLAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.ReportProjectNameData = action.payload;
        });
        builder.addCase(ReportProjectNameDDLAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.ReportProjectNameData = null;
            toastErrorr('Something went wrong')
        });
    },
})
export const ReportProjectNameDDLReducer = ReportProjectNameDDLSlice.reducer

export const ReportWardNameDDLAPI = createAsyncThunk("ReportWardNameDDL", async ({ data }) => {
    const {
        UserID,
        token,
        M_ProjectTypeID,
        ProjectID } = data

    const ProjectType = sessionStorage.getItem("FJ853K")
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    let url
    // if (ProjectType == 9) {
    //     url = `${BaseUrl}/CommonDLLData/Get_DDL_M_Ward_Select?M_UserID=${UserID}`
    // } else {
        url = `${BaseUrl}/CommonDLLData/Get_RM_DDL_WardNameForPenaltyReport_Select?M_ProjectTypeID=${M_ProjectTypeID ? M_ProjectTypeID : '0'}&ProjectID=${ProjectID ? ProjectID : '0'}&M_UserID=${UserID}`
    // }
    return fetch(url, requestOptions)

        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const ReportWardNameDDLSlice = createSlice({
    name: "ReportWardNameDDL",
    initialState: {
        isLoading: false,
        ReportWardNameData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(ReportWardNameDDLAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(ReportWardNameDDLAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.ReportWardNameData = action.payload;
        });
        builder.addCase(ReportWardNameDDLAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.ReportWardNameData = null;
            toastErrorr('Something went wrong')
        });
    },
})
export const ReportWardNameDDLReducer = ReportWardNameDDLSlice.reducer

// ------------WaterSupply Work Type DDL ---------------------
export const WaterSupplyWorkTypeDDLAPI = createAsyncThunk("WaterSupplyWorkTypeDDL", async ({ data }) => {
    const {
        M_UserID,
        token,
        M_ProjectTypeID,
        DashProjectTypeId,
        RoleID,
        ProjectID } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    let url

    if (DashProjectTypeId == 6 && RoleID != '16') {
        url = `${BaseUrl}/CommonDLLData/Get_WEB_WS_DDL_M_Distri_WorkType_Select?M_UserID=${M_UserID}`
    }
    else if (DashProjectTypeId == 9) {
        url = `${BaseUrl}/CommonDLLData/Get_WEB_DDL_M_TTP_WorkType_Select?M_UserID=${M_UserID}`
    }
    else {
        url = `${BaseUrl}/CommonDLLData/Get_WEB_WS_DDL_M_WS_WorkType_Select?M_UserID=${M_UserID}`
    }
    return fetch(url, requestOptions)

        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const WaterSupplyWorkTypeDDLSlice = createSlice({
    name: "WaterSupplyWorkTypeDDL",
    initialState: {
        isLoading: false,
        WaterSupplyWorkTypeData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(WaterSupplyWorkTypeDDLAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(WaterSupplyWorkTypeDDLAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.WaterSupplyWorkTypeData = action.payload;
        });
        builder.addCase(WaterSupplyWorkTypeDDLAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.WaterSupplyWorkTypeData = null;
            toastErrorr('Something went wrong')
        });
    },
})
export const WaterSupplyWorkTypeDDLReducer = WaterSupplyWorkTypeDDLSlice.reducer

// ------------WaterSupply Work Type DDL ---------------------
export const WaterSupplyWorkNameDDLAPI = createAsyncThunk("WaterSupplyWorkNameDDL", async ({ data }) => {
    const {
        M_UserID,
        token,
        M_ProjectTypeID,
        // M_WS_WorkTypeID,
        ProjectID,
        RoleID,
        DashProjectTypeId,
        M_Distri_WorkTypeID } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    let url

    if (DashProjectTypeId == 6 && RoleID != '16') {
        url = `${BaseUrl}/CommonDLLData/Get_WEB_WS_DDL_M_Distri_WorkName_Select?M_Distri_WorkTypeID=${M_Distri_WorkTypeID ? M_Distri_WorkTypeID : '0'}&M_UserID=${M_UserID}`
    }
    else if (DashProjectTypeId == 9) {
        url = `${BaseUrl}/CommonDLLData/Get_WEB_DDL_M_TTP_WorkName_Select?M_TTP_WorkTypeID=${M_Distri_WorkTypeID ? M_Distri_WorkTypeID : '0'}&M_UserID=${M_UserID}`
    }
    else {
        url = `${BaseUrl}/CommonDLLData/Get_WEB_WS_DDL_M_WS_WorkName_Select?M_WS_WorkTypeID=${M_Distri_WorkTypeID ? M_Distri_WorkTypeID : '0'}&M_UserID=${M_UserID}`
    }
    return fetch(url, requestOptions)
        // return fetch(``, requestOptions)

        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const WaterSupplyWorkNameDDLSlice = createSlice({
    name: "WaterSupplyWorkNameDDL",
    initialState: {
        isLoading: false,
        WaterSupplyWorkNameData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(WaterSupplyWorkNameDDLAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(WaterSupplyWorkNameDDLAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.WaterSupplyWorkNameData = action.payload;
        });
        builder.addCase(WaterSupplyWorkNameDDLAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.WaterSupplyWorkNameData = null;
            toastErrorr('Something went wrong')
        });
    },
})
export const WaterSupplyWorkNameDDLReducer = WaterSupplyWorkNameDDLSlice.reducer



export const EnergyStatusDDLAPI = createAsyncThunk("EnergyStatusDDL", async ({ data }) => {
    const {
        M_UserID,
        token } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/CommonDLLData/Get_APK_STP_DDL_M_IndicatorSTPEnergy_Select?M_UserID=${M_UserID}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const EnergyStatusDDLSlice = createSlice({
    name: "EnergyStatusDDL",
    initialState: {
        isLoading: false,
        EnergyStatusData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(EnergyStatusDDLAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(EnergyStatusDDLAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.EnergyStatusData = action.payload;
        });
        builder.addCase(EnergyStatusDDLAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.EnergyStatusData = null;
            toastErrorr('Something went wrong')
        });
    },
})
export const EnergyStatusDDLReducer = EnergyStatusDDLSlice.reducer


export const UnitTypeDDLAPI = createAsyncThunk("UnitTypeDDL", async ({ data }) => {
    const {
        M_UserID,
        token } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/CommonDLLData/Get_WEB_STP_DDL_M_STP_UnitType_Select?M_UserID=${M_UserID}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const UnitTypeDDLSlice = createSlice({
    name: "UnitTypeDDL",
    initialState: {
        isLoading: false,
        UnitTypeData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(UnitTypeDDLAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(UnitTypeDDLAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.UnitTypeData = action.payload;
        });
        builder.addCase(UnitTypeDDLAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.UnitTypeData = null;
            toastErrorr('Something went wrong')
        });
    },
})
export const UnitTypeDDLReducer = UnitTypeDDLSlice.reducer


export const EquipmentTypeDDLAPI = createAsyncThunk("EquipmentTypeDDL", async ({ data }) => {
    const {
        M_STP_UnitTypeID,
        M_UserID,
        token } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/CommonDLLData/Get_WEB_STP_DDL_M_STP_EquipmentType_Select?M_STP_UnitTypeID=${M_STP_UnitTypeID ? M_STP_UnitTypeID : '0'}&M_UserID=${M_UserID}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const EquipmentTypeDDLSlice = createSlice({
    name: "EquipmentTypeDDL",
    initialState: {
        isLoading: false,
        EquipmentTypeData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(EquipmentTypeDDLAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(EquipmentTypeDDLAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.EquipmentTypeData = action.payload;
        });
        builder.addCase(EquipmentTypeDDLAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.EquipmentTypeData = null;
            toastErrorr('Something went wrong')
        });
    },
})
export const EquipmentTypeDDLReducer = EquipmentTypeDDLSlice.reducer


export const MachineryDetailsDDLAPI = createAsyncThunk("MachineryDetailsDDL", async ({ data }) => {
    const {
        M_WardID,
        M_STP_MachEquipmentTypeID,
        M_UserID,
        token } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/CommonDLLData/Get_WEB_STP_DDL_M_STP_MachineryDetails_Select?M_WardID=${M_WardID ? M_WardID : '0'}&M_STP_MachEquipmentTypeID=${M_STP_MachEquipmentTypeID ? M_STP_MachEquipmentTypeID : '0'}&M_UserID=${M_UserID}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const MachineryDetailsDDLSlice = createSlice({
    name: "MachineryDetailsDDL",
    initialState: {
        isLoading: false,
        MachineryDetailsData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(MachineryDetailsDDLAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(MachineryDetailsDDLAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.MachineryDetailsData = action.payload;
        });
        builder.addCase(MachineryDetailsDDLAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.MachineryDetailsData = null;
            toastErrorr('Something went wrong')
        });
    },
})
export const MachineryDetailsDDLReducer = MachineryDetailsDDLSlice.reducer

export const MachEquipmentTypeDDLAPI = createAsyncThunk("MachEquipmentTypeDDL", async ({ data }) => {
    const {
        M_UserID,
        token } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/CommonDLLData/Get_WEB_STP_DDL_M_STP_MachEquipmentType_Select?M_UserID=${M_UserID}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const MachEquipmentTypeDDLSlice = createSlice({
    name: "MachEquipmentTypeDDL",
    initialState: {
        isLoading: false,
        MachEquipmentTypeData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(MachEquipmentTypeDDLAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(MachEquipmentTypeDDLAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.MachEquipmentTypeData = action.payload;
        });
        builder.addCase(MachEquipmentTypeDDLAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.MachEquipmentTypeData = null;
            toastErrorr('Something went wrong')
        });
    },
})
export const MachEquipmentTypeDDLReducer = MachEquipmentTypeDDLSlice.reducer


export const STPStatusTypeDDLAPI = createAsyncThunk("STPStatusTypeDDL", async ({ data }) => {
    const {
        M_UserID,
        token } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/CommonDLLData/Get_WEB_STP_DDL_M_STP_MachineryActions_Select?M_UserID=${M_UserID}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const STPStatusTypeDDLSlice = createSlice({
    name: "STPStatusTypeDDL",
    initialState: {
        isLoading: false,
        STPStatusTypeData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(STPStatusTypeDDLAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(STPStatusTypeDDLAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.STPStatusTypeData = action.payload;
        });
        builder.addCase(STPStatusTypeDDLAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.STPStatusTypeData = null;
            toastErrorr('Something went wrong')
        });
    },
})
export const STPStatusTypeDDLReducer = STPStatusTypeDDLSlice.reducer


export const STPTankMasterDDLAPI = createAsyncThunk("STPTankMasterDDL", async ({ data }) => {
    const {
        M_WardID,
        M_UserID,
        token } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/CommonDLLData/Get_WEB_STP_DDL_M_STP_TankMaster_Select?M_WardID=${M_WardID ? M_WardID : '0'}&M_UserID=${M_UserID}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const STPTankMasterDDLSlice = createSlice({
    name: "STPTankMasterDDL",
    initialState: {
        isLoading: false,
        STPTankMasterData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(STPTankMasterDDLAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(STPTankMasterDDLAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.STPTankMasterData = action.payload;
        });
        builder.addCase(STPTankMasterDDLAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.STPTankMasterData = null;
            toastErrorr('Something went wrong')
        });
    },
})
export const STPTankMasterDDLReducer = STPTankMasterDDLSlice.reducer


export const STPEnergyMPCNoDDLAPI = createAsyncThunk("STPEnergyMPCNoDDL", async ({ data }) => {
    const {
        M_WardID,
        M_UserID,
        token } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/CommonDLLData/Get_WEB_STP_DDL_M_STP_EnergyMPCNo_Select?M_WardID=${M_WardID ? M_WardID : '0'}&M_UserID=${M_UserID}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const STPEnergyMPCNoDDLSlice = createSlice({
    name: "STPEnergyMPCNoDDL",
    initialState: {
        isLoading: false,
        STPEnergyMPCNoData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(STPEnergyMPCNoDDLAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(STPEnergyMPCNoDDLAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.STPEnergyMPCNoData = action.payload;
        });
        builder.addCase(STPEnergyMPCNoDDLAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.STPEnergyMPCNoData = null;
            toastErrorr('Something went wrong')
        });
    },
})
export const STPEnergyMPCNoDDLReducer = STPEnergyMPCNoDDLSlice.reducer


export const EquipmentNameDDLAPI = createAsyncThunk("EquipmentNameDDL", async ({ data }) => {
    const {
        M_WardID,
        M_STP_EquipmentTypeID,
        M_UserID,
        token } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/CommonDLLData/Get_WEB_STP_DDL_M_STP_EquipmentMaster_Select?M_WardID=${M_WardID ? M_WardID : '0'}&M_STP_EquipmentTypeID=${M_STP_EquipmentTypeID ? M_STP_EquipmentTypeID : '0'}&M_UserID=${M_UserID}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const EquipmentNameDDLSlice = createSlice({
    name: "EquipmentNameDDL",
    initialState: {
        isLoading: false,
        EquipmentNameData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(EquipmentNameDDLAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(EquipmentNameDDLAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.EquipmentNameData = action.payload;
        });
        builder.addCase(EquipmentNameDDLAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.EquipmentNameData = null;
            toastErrorr('Something went wrong')
        });
    },
})
export const EquipmentNameDDLReducer = EquipmentNameDDLSlice.reducer


export const ParameterTypeDDLAPI = createAsyncThunk("ParameterTypeDDL", async ({ data }) => {
    const {
        M_UserID,
        token } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/CommonDLLData/Get_WEB_STP_DDL_M_IndicatorParameterType_Select?M_UserID=${M_UserID}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const ParameterTypeDDLSlice = createSlice({
    name: "ParameterTypeDDL",
    initialState: {
        isLoading: false,
        ParameterTypeData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(ParameterTypeDDLAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(ParameterTypeDDLAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.ParameterTypeData = action.payload;
        });
        builder.addCase(ParameterTypeDDLAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.ParameterTypeData = null;
            toastErrorr('Something went wrong')
        });
    },
})
export const ParameterTypeDDLReducer = ParameterTypeDDLSlice.reducer

export const QualityParameterNameDDLAPI = createAsyncThunk("QualityParameterNameDDL", async ({ data }) => {
    const {
        M_IndicatorParameterTypeID,
        M_UserID,
        token } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/CommonDLLData/Get_WEB_STP_DDL_M_STP_QualityParameter_Select?M_IndicatorParameterTypeID=${M_IndicatorParameterTypeID ? M_IndicatorParameterTypeID : '0'}&M_UserID=${M_UserID}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const QualityParameterNameDDLSlice = createSlice({
    name: "QualityParameterNameDDL",
    initialState: {
        isLoading: false,
        QualityParameterNameData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(QualityParameterNameDDLAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(QualityParameterNameDDLAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.QualityParameterNameData = action.payload;
        });
        builder.addCase(QualityParameterNameDDLAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.QualityParameterNameData = null;
            toastErrorr('Something went wrong')
        });
    },
})
export const QualityParameterNameDDLReducer = QualityParameterNameDDLSlice.reducer


export const EquipmentWorkDDLAPI = createAsyncThunk("EquipmentWorkDDL", async ({ data }) => {
    const {
        M_STP_EquipmentMasterID,
        M_STP_WorkPeriodID,
        M_UserID,
        token } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/CommonDLLData/Get_WEB_STP_DDL_M_STP_EquipmentWork_Select?M_STP_EquipmentMasterID=${M_STP_EquipmentMasterID ? M_STP_EquipmentMasterID : '0'}&M_STP_WorkPeriodID=${M_STP_WorkPeriodID ? M_STP_WorkPeriodID : '0'}&M_UserID=${M_UserID}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const EquipmentWorkDDLSlice = createSlice({
    name: "EquipmentWorkDDL",
    initialState: {
        isLoading: false,
        EquipmentWorkData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(EquipmentWorkDDLAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(EquipmentWorkDDLAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.EquipmentWorkData = action.payload;
        });
        builder.addCase(EquipmentWorkDDLAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.EquipmentWorkData = null;
            toastErrorr('Something went wrong')
        });
    },
})
export const EquipmentWorkDDLReducer = EquipmentWorkDDLSlice.reducer

//       WTP Equipment Type DDL

export const WTPEquipmentTypeDDLAPI = createAsyncThunk("WTPEquipmentTypeDDL", async ({ data }) => {
    const {
        UserID,
        token } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/CommonDLLData/Get_WEB_WTP_DDL_M_WTP_EquipmentType_Select?M_UserID=${UserID}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const WTPEquipmentTypeDDLSlice = createSlice({
    name: "WTPEquipmentTypeDDL",
    initialState: {
        isLoading: false,
        WTPEquipmentTypeData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(WTPEquipmentTypeDDLAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(WTPEquipmentTypeDDLAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.WTPEquipmentTypeData = action.payload;
        });
        builder.addCase(WTPEquipmentTypeDDLAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.WTPEquipmentTypeData = null;
            toastErrorr('Something went wrong')
        });
    },
})
export const WTPEquipmentTypeDDLReducer = WTPEquipmentTypeDDLSlice.reducer

//  WTP Filter Battery No DDL

export const WTPFilterBatteryNoDDLAPI = createAsyncThunk("WTPFilterBatteryNoDDL", async ({ data }) => {
    const {
        M_UserID,
        token } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/CommonDLLData/Get_WEB_WTP_DDL_M_WTP_FilterBatteryNo_Select?M_UserID=${M_UserID}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const WTPFilterBatteryNoDDLSlice = createSlice({
    name: "WTPFilterBatteryNoDDL",
    initialState: {
        isLoading: false,
        WTPFilterBatteryNoData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(WTPFilterBatteryNoDDLAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(WTPFilterBatteryNoDDLAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.WTPFilterBatteryNoData = action.payload;
        });
        builder.addCase(WTPFilterBatteryNoDDLAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.WTPFilterBatteryNoData = null;
            toastErrorr('Something went wrong')
        });
    },
})
export const WTPFilterBatteryNoDDLReducer = WTPFilterBatteryNoDDLSlice.reducer

//  WTP Pump Category DDL

export const WTPPumpCategoryDDLAPI = createAsyncThunk("WTPPumpCategoryDDL", async ({ data }) => {
    const {
        M_UserID,
        token } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/CommonDLLData/Get_WEB_WTP_DDL_M_WTP_PumpCategory_Select?M_UserID=${M_UserID}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const WTPPumpCategoryDDLSlice = createSlice({
    name: "WTPPumpCategoryDDL",
    initialState: {
        isLoading: false,
        WTPPumpCategoryData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(WTPPumpCategoryDDLAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(WTPPumpCategoryDDLAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.WTPPumpCategoryData = action.payload;
        });
        builder.addCase(WTPPumpCategoryDDLAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.WTPPumpCategoryData = null;
            toastErrorr('Something went wrong')
        });
    },
})
export const WTPPumpCategoryDDLReducer = WTPPumpCategoryDDLSlice.reducer

//  WTP Plant Name

export const WTPPlantNameDDLAPI = createAsyncThunk("WTPPlantNameDDL", async ({ data }) => {
    const {
        M_WardID,
        M_UserID,
        token } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/CommonDLLData/Get_WEB_WTP_DDL_M_WTP_Plant_Select?M_WardID=${M_WardID ? M_WardID : '0'}&M_UserID=${M_UserID}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const WTPPlantNameDDLSlice = createSlice({
    name: "WTPPlantNameDDL",
    initialState: {
        isLoading: false,
        WTPPlantNameData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(WTPPlantNameDDLAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(WTPPlantNameDDLAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.WTPPlantNameData = action.payload;
        });
        builder.addCase(WTPPlantNameDDLAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.WTPPlantNameData = null;
            toastErrorr('Something went wrong')
        });
    },
})
export const WTPPlantNameDDLReducer = WTPPlantNameDDLSlice.reducer

// WTP Sump Number DDL

export const WTPSumpNumberDDLAPI = createAsyncThunk("WTPSumpNumberDDL", async ({ data }) => {
    const {
        M_WTP_PlantID,
        M_UserID,
        token } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/CommonDLLData/Get_WEB_WTP_DDL_M_WTP_Sump_Select?M_WTP_PlantID=${M_WTP_PlantID ? M_WTP_PlantID : '0'}&M_UserID=${M_UserID}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const WTPSumpNumberDDLSlice = createSlice({
    name: "WTPSumpNumberDDL",
    initialState: {
        isLoading: false,
        WTPSumpNumberData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(WTPSumpNumberDDLAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(WTPSumpNumberDDLAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.WTPSumpNumberData = action.payload;
        });
        builder.addCase(WTPSumpNumberDDLAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.WTPSumpNumberData = null;
            toastErrorr('Something went wrong')
        });
    },
})
export const WTPSumpNumberDDLReducer = WTPSumpNumberDDLSlice.reducer

//  WTP Location Master DDL

export const WTPLocationMasterDDLAPI = createAsyncThunk("WTPLocationMasterDDL", async ({ data }) => {
    const {
        M_WardID,
        M_UserID,
        token } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/CommonDLLData/Get_WEB_WTP_DDL_M_WTP_Location_Select?M_WardID=${M_WardID ? M_WardID : '0'}&M_UserID=${M_UserID}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const WTPLocationMasterDDLSlice = createSlice({
    name: "WTPLocationMasterDDL",
    initialState: {
        isLoading: false,
        WTPLocationMasterData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(WTPLocationMasterDDLAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(WTPLocationMasterDDLAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.WTPLocationMasterData = action.payload;
        });
        builder.addCase(WTPLocationMasterDDLAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.WTPLocationMasterData = null;
            toastErrorr('Something went wrong')
        });
    },
})
export const WTPLocationMasterDDLReducer = WTPLocationMasterDDLSlice.reducer

// WTP Equipment Name DDL

export const WTPEquipmentNameDDLAPI = createAsyncThunk("WTPEquipmentNameDDL", async ({ data }) => {
    const {
        M_WTP_EquipmentTypeID,
        M_UserID,
        token } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/CommonDLLData/Get_WEB_WTP_DDL_M_WTP_EquipmentMaster_Select?M_WTP_EquipmentTypeID=${M_WTP_EquipmentTypeID ? M_WTP_EquipmentTypeID : '0'}&M_UserID=${M_UserID}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const WTPEquipmentNameDDLSlice = createSlice({
    name: "WTPEquipmentNameDDL",
    initialState: {
        isLoading: false,
        WTPEquipmentNameData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(WTPEquipmentNameDDLAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(WTPEquipmentNameDDLAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.WTPEquipmentNameData = action.payload;
        });
        builder.addCase(WTPEquipmentNameDDLAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.WTPEquipmentNameData = null;
            toastErrorr('Something went wrong')
        });
    },
})
export const WTPEquipmentNameDDLReducer = WTPEquipmentNameDDLSlice.reducer

// WTP Action DDL

export const WTPActionDDLAPI = createAsyncThunk("WTPActionDDL", async ({ data }) => {
    const {
        M_UserID,
        token } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/CommonDLLData/Get_WEB_WTP_DDL_M_WTP_MachineryActions_Select?M_UserID=${M_UserID}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const WTPActionDDLSlice = createSlice({
    name: "WTPActionDDL",
    initialState: {
        isLoading: false,
        WTPActionData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(WTPActionDDLAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(WTPActionDDLAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.WTPActionData = action.payload;
        });
        builder.addCase(WTPActionDDLAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.WTPActionData = null;
            toastErrorr('Something went wrong')
        });
    },
})
export const WTPActionDDLReducer = WTPActionDDLSlice.reducer

// WTP Pump Number DDL

export const WTPPumpNumberDDLAPI = createAsyncThunk("WTPPumpNumberDDL", async ({ data }) => {
    const {
        M_WTP_PumpCategoryID,
        M_WTP_SumpID,
        M_UserID,
        token } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/CommonDLLData/Get_WEB_WTP_DDL_M_WTP_Pump_Select?M_WTP_PumpCategoryID=${M_WTP_PumpCategoryID ? M_WTP_PumpCategoryID : '0'}&M_WTP_SumpID=${M_WTP_SumpID ? M_WTP_SumpID : '0'}&M_UserID=${M_UserID}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const WTPPumpNumberDDLSlice = createSlice({
    name: "WTPPumpNumberDDL",
    initialState: {
        isLoading: false,
        WTPPumpNumberData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(WTPPumpNumberDDLAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(WTPPumpNumberDDLAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.WTPPumpNumberData = action.payload;
        });
        builder.addCase(WTPPumpNumberDDLAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.WTPPumpNumberData = null;
            toastErrorr('Something went wrong')
        });
    },
})
export const WTPPumpNumberDDLReducer = WTPPumpNumberDDLSlice.reducer

//  WTP Filter Battery No DDL

export const WTPBedNoDDLAPI = createAsyncThunk("WTPBedNoDDL", async ({ data }) => {
    const {
        M_UserID,
        M_WTP_FilterBatteryNoID,
        token } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/CommonDLLData/Get_WEB_WTP_DDL_M_WTP_BedMaster_Select?M_WTP_FilterBatteryNoID=${M_WTP_FilterBatteryNoID ? M_WTP_FilterBatteryNoID : '0'}&M_UserID=${M_UserID}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const WTPBedNoDDLSlice = createSlice({
    name: "WTPBedNoDDL",
    initialState: {
        isLoading: false,
        WTPBedNoData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(WTPBedNoDDLAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(WTPBedNoDDLAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.WTPBedNoData = action.payload;
        });
        builder.addCase(WTPBedNoDDLAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.WTPBedNoData = null;
            toastErrorr('Something went wrong')
        });
    },
})
export const WTPBedNoDDLReducer = WTPBedNoDDLSlice.reducer




export const ParamaterDDLAPI = createAsyncThunk("ParamaterDDL", async ({ data }) => {
    const {
        Flag,
        WaterQtyM_IndicatorID,
        M_UserID,
        token } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/CommonDLLData/Get_WEB_WTP_DDL_WaterQuality_Select?WaterQtyM_IndicatorID=${WaterQtyM_IndicatorID}&Flag=${Flag}&M_UserID=${M_UserID}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const ParamaterDDLSlice = createSlice({
    name: "ParamaterDDL",
    initialState: {
        isLoading: false,
        ParamaterData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(ParamaterDDLAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(ParamaterDDLAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.ParamaterData = action.payload;
        });
        builder.addCase(ParamaterDDLAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.ParamaterData = null;
            toastErrorr('Something went wrong')
        });
    },
})
export const ParamaterDDLReducer = ParamaterDDLSlice.reducer



export const TimeDDLAPI = createAsyncThunk("TimeDDL", async ({ data }) => {
    const {
        M_UserID,
        token } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/CommonDLLData/Get_APK_WS_DDL_M_WS_Time_Select?M_UserID=${M_UserID}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const TimeDDLSlice = createSlice({
    name: "TimeDDL",
    initialState: {
        isLoading: false,
        TimeData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(TimeDDLAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(TimeDDLAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.TimeData = action.payload;
        });
        builder.addCase(TimeDDLAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.TimeData = null;
            toastErrorr('Something went wrong')
        });
    },
})
export const TimeDDLReducer = TimeDDLSlice.reducer

// WTP Ward Name DDL 
export const WTPWardNameDDLAPI = createAsyncThunk("WTPWardNameDDL", async ({ data }) => {
    const {
        Flag,
        M_WardID,
        M_UserID,
        token } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/CommonDLLData/Get_WEB_WTP_DDL_M_Ward_Select?M_WardID=${M_WardID}&Flag=${Flag}&M_UserID=${M_UserID}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const WTPWardNameDDLSlice = createSlice({
    name: "WTPWardNameDDL",
    initialState: {
        isLoading: false,
        WTPWardNameData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(WTPWardNameDDLAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(WTPWardNameDDLAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.WTPWardNameData = action.payload;
        });
        builder.addCase(WTPWardNameDDLAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.WTPWardNameData = null;
            toastErrorr('Something went wrong')
        });
    },
})
export const WTPWardNameDDLReducer = WTPWardNameDDLSlice.reducer



//Electrical Location DDL

export const LocationNameELDDLAPI = createAsyncThunk("LocationNameELDDL", async ({ data }) => {
    const {
        Flag,
        M_WardID,
        M_UserID,
        token } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/CommonDLLData/Get_DDL_M_ELEC_Location_Select?M_WardID=${M_WardID}&Flag=${Flag}&M_UserID=${M_UserID}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const LocationNameELDDLSlice = createSlice({
    name: "LocationNameELDDL",
    initialState: {
        isLoading: false,
        LocationNameData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(LocationNameELDDLAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(LocationNameELDDLAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.LocationNameData = action.payload;
        });
        builder.addCase(LocationNameELDDLAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.LocationNameData = null;
            toastErrorr('Something went wrong')
        });
    },
})
export const LocationNameELDDLReducer = LocationNameELDDLSlice.reducer



//Electrical Piller DDL

export const PillerELDDLAPI = createAsyncThunk("PillerELDDL", async ({ data }) => {
    const {
        M_ELEC_LocationID,
        Flag,
        M_WardID,
        M_UserID,
        token } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/CommonDLLData/Get_DDL_M_ELEC_Piller_Select?M_WardID=${M_WardID}&M_ELEC_LocationID=${M_ELEC_LocationID}&Flag=${Flag}&M_UserID=${M_UserID}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const PillerELDDLSlice = createSlice({
    name: "PillerELDDL",
    initialState: {
        isLoading: false,
        PillerData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(PillerELDDLAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(PillerELDDLAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.PillerData = action.payload;
        });
        builder.addCase(PillerELDDLAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.PillerData = null;
            toastErrorr('Something went wrong')
        });
    },
})
export const PillerELDDLReducer = PillerELDDLSlice.reducer


//Electrical Pole DDL

export const PoleELDDLAPI = createAsyncThunk("PoleELDDL", async ({ data }) => {
    const {
        M_ELEC_LocationID,
        M_ELEC_PillerID,
        Flag,
        M_WardID,
        M_UserID,
        token } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/CommonDLLData/Get_DDL_M_ELEC_Pole_Select?M_WardID=${M_WardID}&M_ELEC_LocationID=${M_ELEC_LocationID}&M_ELEC_PillerID=${M_ELEC_PillerID}&Flag=${Flag}&M_UserID=${M_UserID}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const PoleELDDLSlice = createSlice({
    name: "PoleELDDL",
    initialState: {
        isLoading: false,
        PoleData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(PoleELDDLAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(PoleELDDLAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.PoleData = action.payload;
        });
        builder.addCase(PoleELDDLAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.PoleData = null;
            toastErrorr('Something went wrong')
        });
    },
})
export const PoleELDDLReducer = PoleELDDLSlice.reducer



// Electrical DDL

export const EleWorkTypeDDLAPI = createAsyncThunk("EleWorkTypeDDL", async ({ data }) => {
    const {
        Flag,
        M_UserID,
        token } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    return fetch(`${BaseUrl}/CommonDLLData/Get_DDL_M_ELEC_WorkType_Select?Flag=${Flag}&M_UserID=${M_UserID}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const EleWorkTypeDDLSlice = createSlice({
    name: "EleWorkTypeDDL",
    initialState: {
        isLoading: false,
        WorkTypeData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(EleWorkTypeDDLAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(EleWorkTypeDDLAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.WorkTypeData = action.payload;
        });
        builder.addCase(EleWorkTypeDDLAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.WorkTypeData = null;
            toastErrorr('Something went wrong')
        });
    },
})
export const EleWorkTypeDDLReducer = EleWorkTypeDDLSlice.reducer



export const EleWorkSubTypeDDLAPI = createAsyncThunk("EleWorkSubTypeDDL", async ({ data }) => {
    const {
        M_ELEC_WorkTypeID,
        Flag,
        M_UserID,
        token } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    return fetch(`${BaseUrl}/CommonDLLData/Get_DDL_M_ELEC_WorkSubType_Select?M_ELEC_WorkTypeID=${M_ELEC_WorkTypeID}&Flag=${Flag}&M_UserID=${M_UserID}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const EleWorkSubTypeDDLSlice = createSlice({
    name: "EleWorkSubTypeDDL",
    initialState: {
        isLoading: false,
        WorkTypeData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(EleWorkSubTypeDDLAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(EleWorkSubTypeDDLAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.WorkTypeData = action.payload;
        });
        builder.addCase(EleWorkSubTypeDDLAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.WorkTypeData = null;
            toastErrorr('Something went wrong')
        });
    },
})
export const EleWorkSubTypeDDLReducer = EleWorkSubTypeDDLSlice.reducer

export const EleWorkDDLAPI = createAsyncThunk("EleWorkDDL", async ({ data }) => {
    const {
        M_ELEC_WorkTypeID,
        M_ELEC_WorkSubTypeID,
        Flag,
        M_UserID,
        token } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    return fetch(`${BaseUrl}/CommonDLLData/Get_DDL_M_ELEC_Work_Select?M_ELEC_WorkTypeID=${M_ELEC_WorkTypeID}&M_ELEC_WorkSubTypeID=${M_ELEC_WorkSubTypeID}&Flag=${Flag}&M_UserID=${M_UserID}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const EleWorkDDLSlice = createSlice({
    name: "EleWorkDDL",
    initialState: {
        isLoading: false,
        WorkTypeData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(EleWorkDDLAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(EleWorkDDLAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.WorkTypeData = action.payload;
        });
        builder.addCase(EleWorkDDLAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.WorkTypeData = null;
            toastErrorr('Something went wrong')
        });
    },
})
export const EleWorkDDLReducer = EleWorkDDLSlice.reducer


// Electrical DDL

export const EleStatusDDLAPI = createAsyncThunk("EleStatusDDL", async ({ data }) => {
    const {
        Flag,
        M_UserID,
        token
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/CommonDLLData/Get_DDL_M_ELEC_Status_Select?Flag=${Flag}&M_UserID=${M_UserID}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const EleStatusDDLSlice = createSlice({
    name: "EleStatusDDL",
    initialState: {
        isLoading: false,
        StatusData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(EleStatusDDLAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(EleStatusDDLAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.StatusData = action.payload;
        });
        builder.addCase(EleStatusDDLAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.StatusData = null;
            toastErrorr('Something went wrong')
        });
    },
})
export const EleStatusDDLReducer = EleStatusDDLSlice.reducer


// Electric Project Name DDL

export const ElEProjectNameDDLAPI = createAsyncThunk("ElEProjectNameDDL", async ({ data }) => {
    const {
        M_ProjectTypeID,
        Flag,
        M_UserID,
        token
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    return fetch(`${BaseUrl}/CommonDLLData/Get_DDL_M_ProjectTypeWise_M_ProjectSelect?M_ProjectTypeID=${M_ProjectTypeID}&Flag=${Flag}&M_UserID=${M_UserID}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const ElEProjectNameDDLSlice = createSlice({
    name: "ElEProjectNameDDL",
    initialState: {
        isLoading: false,
        GDProjectData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(ElEProjectNameDDLAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(ElEProjectNameDDLAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.GDProjectData = action.payload;
        });
        builder.addCase(ElEProjectNameDDLAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.GDProjectData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const ElEProjectNameDDLReducer = ElEProjectNameDDLSlice.reducer

export const Get_DDL_M_Contractor_Grid_SelectDDLAPI = createAsyncThunk("Get_DDL_M_Contractor_Grid_SelectDDL", async ({ data }) => {
    const {
        M_ProjectTypeID,
        M_ProjectID,
        M_ContractorID,
        Flag,
        M_UserID,
        token
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    return fetch(`${BaseUrl}/CommonDLLData/Get_DDL_M_Contractor_Grid_Select?M_ProjectTypeID=${M_ProjectTypeID ? M_ProjectTypeID : '0'}&M_ProjectID=${M_ProjectID ? M_ProjectID : '0'}&M_ContractorID=${M_ContractorID ? M_ContractorID : '0'}&Flag=${Flag ? Flag : '1'}&M_UserID=${M_UserID}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const Get_DDL_M_Contractor_Grid_SelectDDLSlice = createSlice({
    name: "Get_DDL_M_Contractor_Grid_SelectDDL",
    initialState: {
        isLoading: false,
        ContractorNameDDLData: {},
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(Get_DDL_M_Contractor_Grid_SelectDDLAPI.pending, (state) => {
            state.isLoading = true;
        });
        builder.addCase(Get_DDL_M_Contractor_Grid_SelectDDLAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            const key = (action.meta.arg?.data?.Flag || '').trim();
            state.ContractorNameDDLData = {
                ...state.ContractorNameDDLData,
                [key]: action.payload,
            };
        });
        builder.addCase(Get_DDL_M_Contractor_Grid_SelectDDLAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            toastErrorr('Something went wrong')
        });
    },
})

export const Get_DDL_M_Contractor_Grid_SelectDDLReducer = Get_DDL_M_Contractor_Grid_SelectDDLSlice.reducer


export const Get_DDL_M_Ward_Grid_SelectDDLAPI = createAsyncThunk("Get_DDL_M_Ward_Grid_SelectDDL", async ({ data }) => {
    const {
        APIFlag,
        UserID,
        token
    } = data

    const ProjectType = sessionStorage.getItem("FJ853K")

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    let url
    if (ProjectType == 9) {
        url = `${BaseUrl}/CommonDLLData/Get_DDL_M_Ward_Select?M_UserID=${UserID}`
    } else {
        url = `${BaseUrl}/CommonDLLData/Get_DDL_M_Ward_Grid_Select?Flag=${APIFlag ? APIFlag : '1'}&M_UserID=${UserID}`
    }

    return fetch(url, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const Get_DDL_M_Ward_Grid_SelectDDLSlice = createSlice({
    name: "Get_DDL_M_Ward_Grid_SelectDDL",
    initialState: {
        isLoading: false,
        WardNameDDLData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(Get_DDL_M_Ward_Grid_SelectDDLAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(Get_DDL_M_Ward_Grid_SelectDDLAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.WardNameDDLData = action.payload;
        });
        builder.addCase(Get_DDL_M_Ward_Grid_SelectDDLAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.WardNameDDLData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const Get_DDL_M_Ward_Grid_SelectDDLReducer = Get_DDL_M_Ward_Grid_SelectDDLSlice.reducer


export const Get_DDL_M_Project_Grid_SelectDDLAPI = createAsyncThunk("Get_DDL_M_Project_Grid_SelectDDL", async ({ data }) => {
    const {
        M_ProjectTypeID,
        APIFlag,
        UserID,
        token
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    return fetch(`${BaseUrl}/CommonDLLData/Get_DDL_M_Project_Grid_Select?M_ProjectTypeID=${M_ProjectTypeID ? M_ProjectTypeID : '1'}&Flag=${APIFlag ? APIFlag : '1'}&M_UserID=${UserID}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const Get_DDL_M_Project_Grid_SelectDDLSlice = createSlice({
    name: "Get_DDL_M_Project_Grid_SelectDDL",
    initialState: {
        isLoading: false,
        ProjectNameDDLData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(Get_DDL_M_Project_Grid_SelectDDLAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(Get_DDL_M_Project_Grid_SelectDDLAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.ProjectNameDDLData = action.payload;
        });
        builder.addCase(Get_DDL_M_Project_Grid_SelectDDLAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.ProjectNameDDLData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const Get_DDL_M_Project_Grid_SelectDDLReducer = Get_DDL_M_Project_Grid_SelectDDLSlice.reducer


export const ProjectNameIUDDLAPI = createAsyncThunk("ProjectNameIUDDL", async ({ data }) => {
    const {
        ProjectType,
        WardID,
        Flag,
        UserID,
        token } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    return fetch(`${BaseUrl}/CommonDLLData/Get_DDL_M_ProjectTypeWise_M_ProjectSelect?M_ProjectTypeID=${ProjectType}&M_WardID=${WardID}&Flag=${Flag}&M_UserID=${UserID}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const ProjectNameIUDDLSlice = createSlice({
    name: "ProjectNameIUDDL",
    initialState: {
        isLoading: false,
        ProjectNameIUDDLDataa: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(ProjectNameIUDDLAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(ProjectNameIUDDLAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.ProjectNameIUDDLDataa = action.payload;
        });
        builder.addCase(ProjectNameIUDDLAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.ProjectNameIUDDLDataa = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const ProjectNameIUDDLReducer = ProjectNameIUDDLSlice.reducer


export const WardNameGDDLAPI = createAsyncThunk("WardNameGDDL", async ({ data }) => {
    const {
        M_WardID,
        M_ZoneID,
        M_ProjectTypeID,
        Flag,
        M_UserID,
        token
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    let url
    if (M_ProjectTypeID == 9) {
        url = `${BaseUrl}/CommonDLLData/Get_DDL_M_Ward_Select?M_UserID=${M_UserID}`
    } else {
        url = `${BaseUrl}/CommonDLLData/Get_DDL_M_ProjectType_Wise_M_Ward_Select?M_WardID=${M_WardID}&M_ZoneID=${M_ZoneID}&M_ProjectTypeID=${M_ProjectTypeID}&Flag=${Flag}&M_UserID=${M_UserID}`
    }
    return fetch(url, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const WardNameGDDLSlice = createSlice({
    name: "WardNameGDDL",
    initialState: {
        isLoading: false,
        WardNameGDDLDataa: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(WardNameGDDLAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(WardNameGDDLAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.WardNameGDDLDataa = action.payload;
        });
        builder.addCase(WardNameGDDLAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.WardNameGDDLDataa = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const WardNameGDDLReducer = WardNameGDDLSlice.reducer


export const EmployeeGridDDLAPI = createAsyncThunk("EmployeeGridDDL", async ({ data }) => {
    const {
        M_ProjectTypeID,
        M_ProjectID,
        M_DesignationID,
        M_EmployeeID,
        Flag,
        M_UserID,
        token,
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    let url = `${BaseUrl}/CommonDLLData/Get_DDL_M_Project_Wise_M_Employee_Select?M_ProjectTypeID=${M_ProjectTypeID}&M_ProjectID=${M_ProjectID}&M_DesignationID=${M_DesignationID}&M_EmployeeID=${M_EmployeeID}&Flag=${Flag}&M_UserID=${M_UserID}`;

    return fetch(url, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const EmployeeGridDDLSlice = createSlice({
    name: "EmployeeGridDDL",
    initialState: {
        isLoading: false,
        EmpGridDDLData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(EmployeeGridDDLAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(EmployeeGridDDLAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.EmpGridDDLData = action.payload;
        });
        builder.addCase(EmployeeGridDDLAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.EmpGridDDLData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const EmployeeGridDDLReducer = EmployeeGridDDLSlice.reducer
